const DISPLAY_ACTION = {
  NO_ACTION: 'NO_ACTION',
  HIDE_ELEMENT: 'HIDE_ELEMENT',
  SHOW_ELEMENT: 'SHOW_ELEMENT',
  DISABLE_ELEMENT: 'DISABLE_ELEMENT',
  ENABLE_ELEMENT: 'ENABLE_ELEMENT',
  MODIFY_ATTRIBUTES_OR_CLASSES: 'MODIFY_ATTRIBUTES_OR_CLASSES',
  SET_TEXT: 'SET_TEXT'
};

export default DISPLAY_ACTION;
